import { CircleAlert } from 'lucide-react'
import clsx from 'clsx'

interface AuthButtonProps {
  image?: string
  icon?: React.ReactNode
  label: string
  available?: boolean
  oopsError?: boolean
  missingScopes?: boolean
  unavailableCalendar?: boolean
  calendarNotFound?: boolean
  workEmailRequired?: boolean
  onClick?: () => void
}

function ErrorPanel({ message }: { message: string }) {
  return (
    <div className='fv:flex fv:max-w-80 fv:items-center fv:gap-2.5 fv:text-orange-600 fv:mt-3'>
      <CircleAlert className='fv:size-4! fv:shrink-0' />
      <p className='fv:flex-1 fv:text-xs'>
        <span className='fv:font-semibold'>Oops! </span>
        {message}
      </p>
    </div>
  )
}

export function AuthButton({
  image,
  icon,
  label,
  available = true,
  oopsError,
  missingScopes,
  unavailableCalendar,
  calendarNotFound,
  workEmailRequired,
  onClick,
}: AuthButtonProps) {
  return (
    <div className='fv:flex fv:flex-col fv:gap-2'>
      <button
        type='submit'
        disabled={!available}
        onClick={onClick}
        className={clsx(
          'fv:relative fv:flex fv:items-center fv:justify-center fv:w-72 fv:h-14 fv:rounded-md',
          'fv:bg-white fv:border-[0.75px] fv:border-solid fv:border-gray-300',
          'fv:text-black fv:text-base fv:font-medium',
          'fv:transition fv:duration-200 fv:hover:opacity-90',
          !available && 'fv:pointer-events-none fv:opacity-50',
        )}
      >
        <span className='fv:flex fv:items-center fv:gap-3'>
          {image && <img src={image} alt='' className='fv:size-4' />}
          {icon && <span className='fv:size-4 fv:flex fv:items-center fv:justify-center'>{icon}</span>}
          <span>{label}</span>
        </span>
        {!available && (
          <span className='fv:absolute fv:right-2 fv:px-1.5 fv:py-0.5 fv:text-tiny fv:font-bold fv:text-gray-400 fv:uppercase fv:rounded-md fv:border fv:border-gray-300'>
            Coming Soon
          </span>
        )}
      </button>
      {missingScopes && <ErrorPanel message='All requested permissions are required.' />}
      {oopsError && <ErrorPanel message='Sorry, we were unable to authenticate you. Please try again.' />}
      {unavailableCalendar && <ErrorPanel message='Calendar connected by another user.' />}
      {calendarNotFound && <ErrorPanel message='Calendar not found.' />}
      {workEmailRequired && <ErrorPanel message='Fathom requires a work email' />}
    </div>
  )
}
